import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../../config/siteConfig";

const LEGAL_LINKS = [
  { to: "/legal?tab=aviso", label: "Aviso Legal" },
  { to: "/legal?tab=terms", label: "Términos y Condiciones" },
  { to: "/legal?tab=privacy", label: "Política de Privacidad" },
];

const Footer = () => {
  const { brand, uiCopy } = siteConfig;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-gradient-to-br from-violet-500 to-purple-600 p-2.5 rounded-xl">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-xl font-extrabold text-white">
                  {brand.namePrefix}
                  <span className="text-violet-400">{brand.nameSuffix}</span>
                </span>
                {brand.subBrand && (
                  <span className="text-[10px] font-bold text-slate-400 mt-0.5 tracking-tighter">
                    {brand.subBrand}
                  </span>
                )}
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed">
              {brand.tagline}
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">{uiCopy.landing.productNavLabel}</h3>
            <ul className="space-y-3">
              {uiCopy.landing.productLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-violet-400 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-sm text-slate-400 hover:text-violet-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {year} {brand.name} {brand.subBrand} — Operado por PAUL BREMOND
            SAS. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-sm text-slate-500">
              {brand.flagEmoji} {brand.madeInLabel}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
